/*
  『ARTISTS 検索処理』
  フリーワード対応のため検索処理をJavaScriptで実装する
  
  ※処理の都合上、Snippetファイルで実装

  ●変数
   ・取得記事一覧:blog_posts
*/

const fetchSectionName = "custom-main-blog--artist-list-item";
let article_list_original = [],
  article_list_ordered = [];
let current_page = 1,
  total_page = 1;
const searchResult = document.getElementById('artist-list-contents');
const dips_per_page = searchResult.dataset.articles_per_page;

// 初期表示：検索結果取得
const handleResponse = () => {
  // ーーー 取得ページ件数(1ページ) ーーー

  const sectionUrlItems = [
    `${location.pathname}?sections=${fetchSectionName}&page=1`
  ];
  const initialPagination = ()=>{
    current_page = 1;
    total_page =Math.ceil( article_list_original.length / dips_per_page );

    // ページネーション
    renderPaginate(total_page,current_page);
  }

  (async ()=>{
    //初期化処理
    //bonusinfo.reduce ：bonusinfo配列の中身だけ、api処理を行う
    await sectionUrlItems.reduce((promise, urlItem) => {
      return promise.then(async () => {
        //fetchItem() api処理
        await fetchItem(urlItem);
      });
    }, Promise.resolve());

    //初期化処理完了後、ページネーション初期化
    initialPagination();
  }).call();
}

window.addEventListener('load', handleResponse);

//初期化処理 true/falseを返し、reduce()した処理で全てtrueならPromise 成功
async function fetchItem(_sectionUrl) {
  const sectionUrl = _sectionUrl;
  const requestChangeOptions = {
    credentials: 'same-origin',
    method: 'GET'
  }

  await fetch(sectionUrl,requestChangeOptions)
    .then(response => response.json())
    .then(content => {
      // fetch通信成功時処理
      const dom_wrapper = document.createElement('div');
      dom_wrapper.innerHTML = content[fetchSectionName];
      const dom_deck_elems = dom_wrapper.querySelectorAll('[data-artist_name_ja]');

      // 検索ワード取得

      const urlParams = new URLSearchParams(window.location.search);
      const queryWord = urlParams.get('word') ? urlParams.get('word').toLowerCase().replace(/[\s　]/g, '') : "";
  
      dom_deck_elems.forEach((elem,index)=>{
        let artist_name_ja_text = elem.dataset.artist_name_ja.toLowerCase().replace(/[\s　]/g, ''),
            artist_name_en_text = elem.dataset.artist_name_en.toLowerCase().replace(/[\s　]/g, ''),
            artist_belonging_ja_text = elem.dataset.artist_belonging_ja.toLowerCase().replace(/[\s　]/g, ''),
            artist_belonging_en_text = elem.dataset.artist_belonging_en.toLowerCase().replace(/[\s　]/g, ''),
            artist_countryname_ja_text = elem.dataset.artist_countryname_ja.toLowerCase().replace(/[\s　]/g, ''),
            artist_countryname_en_text = elem.dataset.artist_countryname_en.toLowerCase().replace(/[\s　]/g, ''),
            artist_provincename_ja_text = elem.dataset.artist_provincename_ja.toLowerCase().replace(/[\s　]/g, ''),
            artist_provincename_en_text = elem.dataset.artist_provincename_en.toLowerCase().replace(/[\s　]/g, ''),
            artist_profile_ja_text = elem.dataset.artist_profile_ja.toLowerCase().replace(/[\s　]/g, ''),
            artist_profile_en_text = elem.dataset.artist_profile_en.toLowerCase().replace(/[\s　]/g, ''),
            // 2024.9.26 取得ロジック変更に伴い
            // article_artworks_ja_text = elem.dataset.article_artworks_ja.toLowerCase().replace(/[\s　]/g, ''),
            // article_artworks_en_text = elem.dataset.article_artworks_en.toLowerCase().replace(/[\s　]/g, '');
            article_artworks_ja_text = elem.querySelector("[data-article_artworks_ja]")
              ? elem.querySelector("[data-article_artworks_ja]").dataset.article_artworks_ja.toLowerCase().replace(/[\s　]/g, '')
              : "",
            article_artworks_en_text = elem.querySelector("[data-article_artworks_en]")
              ? elem.querySelector("[data-article_artworks_en]").dataset.article_artworks_en.toLowerCase().replace(/[\s　]/g, '')
              : "";
        if(queryWord && queryWord.length > 0 && (
          artist_name_ja_text.indexOf(queryWord) >-1 
          || artist_name_en_text.indexOf(queryWord) >-1 
          || artist_belonging_ja_text.indexOf(queryWord) >-1 
          || artist_belonging_en_text.indexOf(queryWord) >-1 
          || artist_countryname_ja_text.indexOf(queryWord) >-1 
          || artist_countryname_en_text.indexOf(queryWord) >-1 
          || artist_provincename_ja_text.indexOf(queryWord) >-1 
          || artist_provincename_en_text.indexOf(queryWord) >-1 
          || artist_profile_ja_text.indexOf(queryWord) >-1 
          || artist_profile_en_text.indexOf(queryWord) >-1 
          || article_artworks_ja_text.indexOf(queryWord) >-1 
          || article_artworks_en_text.indexOf(queryWord) >-1 
        )){
          // タイトルに検索ワードを含む記事のみ表示
          article_list_original.push({
            HTML:elem,
            OrderSelected50: elem.dataset.flg_selected50 === "true" ? 1 : 2,
            ArtistSortOrder: elem.dataset.artist_sort_order ? parseInt(elem.dataset.artist_sort_order) : 999
          });

          const wordInput = document.getElementById('search-free-word');
          wordInput.value = queryWord;
          wordInput.closest(".c-ArtistListBlog__WordForm").classList.add("has-query");
        }else if(!queryWord){
          // 通常表示
          article_list_original.push({
            HTML:elem,
            OrderSelected50: elem.dataset.flg_selected50 === "true" ? 1 : 2,
            ArtistSortOrder: elem.dataset.artist_sort_order ? parseInt(elem.dataset.artist_sort_order) : 999
          })
        }
      });

      searchResult.innerHTML = "";
      searchResult.classList.remove("is-loading");
      if(article_list_original.length > 0){
        // 検索結果がある場合
        // 検索結果の1ページ目をレンダリング

        // OrderSelected50でソートし、さらにArtistSortOrderでソート
        article_list_ordered = article_list_original.sort((a, b) => {
          if(a.OrderSelected50 === b.OrderSelected50){
            return a.ArtistSortOrder - b.ArtistSortOrder;
          }else{
            return a.OrderSelected50 - b.OrderSelected50;
          }
        });

        if(sectionUrl.indexOf('&page=1') != -1){
          for (let i=0; i<dips_per_page; i++) {
            if(article_list_ordered.length > i){
              searchResult.appendChild(article_list_ordered[i]?.HTML)
            }else{
              break;
            }
          }
        }
      }else{
        // 検索結果がない場合
        const blankElem = document.createElement("div");
        blankElem.classList.add("ArticleList__NoResult","Grid__Cell")
        blankElem.insertAdjacentHTML('beforeend',`
          <p>条件にあうアーティストが見つかりませんでした。</p>
          <a href="${location.pathname}" class="Button Button--primary">一覧に戻る</a>
        `)
        // blankElem.textContent = "条件にあうアーティストが見つかりませんでした。";
        // blankElem.classList.add("ArticleList__NoResult")
        searchResult.appendChild(blankElem)
      }

      return true
    })
    .catch(error => {
      console.error('Error:', error);
      return false
    });
}

// ページネーション押下時
const paginationFunc = (_direction)=>{
  switch (_direction){
    case 'next':
      //"次へ"
      current_page += 1;
      break;
    case 'prev':
      //"前へ"
      current_page -= 1;
      break;
    default:
      //"数値指定"
      current_page=_direction
      
  }
  //ページネーション結果をレンダリング
  searchResult.innerHTML="";
  for (let i=(current_page-1)*dips_per_page; i<(current_page * dips_per_page); i++) {
    if(article_list_ordered.length > i){
      searchResult.appendChild(article_list_ordered[i]?.HTML)
    }else{
      break;
    }
  }
  renderPaginate()
}

// ページネーション レンダリング
const renderPaginate = () =>{
  document.getElementById("pagination-nav").innerHTML="";
  if(total_page <= 7){
    for(let i=1; i<=total_page; i++){
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <button class="Pagination__NavItem Link Link--primary ${i === current_page ? "is-active" : ""}" title="Go to ${i}" onclick="paginationFunc(${i})">
          ${i}
        </button>
      `)
    }
  }else{
    //1ページ目
    if(current_page !== 1){
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <button id="pagination-prev" class="Pagination__NavItem Link Link--primary" rel="prev" title="前へ" onclick="paginationFunc('prev')">
          <svg class="Icon Icon--custom-select-arrow-left " xmlns="http://www.w3.org/2000/svg" width="14.892" height="4.164" viewBox="0 0 14.892 4.164">
            <path id="パス_953" data-name="パス 953" d="M1863.511,6360.5H1850.5l5.646-3.229" transform="translate(-1848.619 -6356.836)" fill="none" stroke="currentColor" stroke-width="1"></path>
          </svg>
        </button>
      `)
    }
    if(current_page-2 > 1){
      let i = 1;
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <button class="Pagination__NavItem Link Link--primary ${i === current_page ? "is-active" : ""}" title="Go to ${i}" onclick="paginationFunc(${i})">
          ${i}
        </button>
      `)
    }
    if(current_page-3 > 1){
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <span class="Pagination__NavItem">…</span>
      `)
    }
    //中間ページ
    for(let i=current_page-2; i<=current_page+2; i++){
      if(1 <= i && i <= total_page)
        document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
          <button class="Pagination__NavItem Link Link--primary ${i === current_page ? "is-active" : ""}" title="Go to ${i}" onclick="paginationFunc(${i})">
            ${i}
          </button>
        `)
    }
    //最終ページ
    if(current_page+3 < total_page){
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <span class="Pagination__NavItem">…</span>
      `)
    }
    if(current_page+2 < total_page){
      let i = total_page;
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <button class="Pagination__NavItem Link Link--primary ${i === current_page ? "is-active" : ""}" title="Go to ${i}" onclick="paginationFunc(${i})">
          ${i}
        </button>
      `)
    }
    if(current_page !== total_page){
      document.getElementById("pagination-nav").insertAdjacentHTML('beforeend',`
        <button id="pagination-next" class="Pagination__NavItem Link Link--primary" rel="next" title="次へ" onclick="paginationFunc('next')">
          <svg class="Icon Icon--custom-select-arrow-right " xmlns="http://www.w3.org/2000/svg" width="14.892" height="4.164" viewBox="0 0 14.892 4.164">
            <path id="パス_954" data-name="パス 954" d="M1850.5,6360.5h13.011l-5.646-3.229" transform="translate(-1850.5 -6356.836)" fill="none" stroke="currentColor" stroke-width="1"></path>
          </svg>
        </button>
      `)
    }
  }

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}